
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { AppApis } from '../../shared/app.apis';
import { ApiResponse } from '../../shared/app.models';

export interface FeatureFlags {
  [key: string]: boolean;
}
@Injectable({
  providedIn: 'root'
})
export class CommonService {

  private featureFlags: FeatureFlags = {};

  constructor(private http: HttpClient) {}

  async getFeatureFlags(): Promise<FeatureFlags> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<FeatureFlags>>(AppApis.featureFlags.url)
    );

    this.featureFlags = response.Data ?? {};

    return this.featureFlags;
  }

  isFeatureEnabled(name: string): boolean {
    return this.featureFlags[name] ?? false;
  }

  getAllFeatureFlags(): FeatureFlags {
    return { ...this.featureFlags };
  }
}
